import createAxiosInstance, { promiseTimeout } from "../axiosClient"

export async function getValidarCarteirinha(codigo: string, empPadrao: string, token: string) {
    const axiosClient = await createAxiosInstance()
    const request = axiosClient.get(`/validar/carteirinha/${codigo}/${empPadrao}`, {
        headers: {'x-access-token': token}
    })
    return promiseTimeout(request)
}